import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get, map, filter, size, isEmpty, includes } from "lodash";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import { fetchGet } from "../../api/fetch";
import CloseIcon from "../Common/CloseIcon";
import CustomButton from "../Common/CustomButton";
import Loader from "../Common/Loader";
import ProfileViewMatched from "./ProfileView/ProfileViewMatched";
import { getLov } from "../../utils/lov";
import { getProfileTypeIcon } from "../../utils/profile";
import colors from "../../assets/style/colors";

const styles = {
  dialogPaper: {
    minWidth: "800px",
    width: "calc(100vw - 100px)",
    maxWidth: "1000px",
    padding: "12px 0px 0px",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const ProfileDialog = (props) => {
  const { classes, profileId, name } = props;
  const [open, setOpen] = React.useState(props.open);
  const [profile, setProfile] = React.useState();
  const [lov, setLov] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);

  React.useEffect(() => {
    if (profileId && open) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId, open]);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      let profile = await fetchGet(`profiles/${profileId}`);
      let profileAttributes = await fetchGet(
        `profile_types/${get(profile, ["type", "id"])}/attributes`
      );
      let lovAttributes = map(
        filter(profileAttributes, (attr) =>
          includes(["lov(picker)", "radiobutton"], get(attr, ["data_type"]))
        ),
        (attr) => attr.id
      );
      let lov = {
        tag: await getLov("tags"),
      };
      for (let i = 0; i < size(lovAttributes); i++) {
        let attr = get(lovAttributes, [i]);
        lov[attr] = await getLov(attr);
      }
      setLov({
        ...lov,
        profileAttributes,
      });
      setProfile(profile);
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  const closeDialog = () => {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <>
      {props.open === undefined && (
        <span className={classes.link} onClick={() => setOpen(true)}>
          {name}
        </span>
      )}
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={3} style={{ paddingLeft: "12px" }}>
                <CustomButton
                  color="primary"
                  onClick={() =>
                    props.history.push(`/profiles/${get(profile, ["id"])}`)
                  }
                >
                  {I18n.get("profiles_goToFullProfile")}
                </CustomButton>
              </Grid>
              <Grid item xs>
                <Grid container alignItems="center" justify="center">
                  {get(profile, ["type", "id"]) && (
                    <Grid item style={{ marginRight: "10px" }}>
                      <img
                        src={getProfileTypeIcon(get(profile, ["type", "id"]))}
                        style={{ maxWidth: "40px", maxHeight: "20px" }}
                        alt={"profile_icon"}
                      />
                    </Grid>
                  )}
                  <Grid className="text-87 bold-500">{name}</Grid>
                </Grid>
              </Grid>
              <Grid item xs={3} className={classes.closeIcon}>
                <CloseIcon closeFunction={closeDialog} />
              </Grid>
            </Grid>
          </Grid>
          {isFetching && (
            <Grid item style={{ display: "flex", height: "300px" }}>
              <Loader noDecoration />
            </Grid>
          )}
          {!isEmpty(profile) && !isFetching && (
            <ProfileViewMatched
              profile={profile}
              profileType={get(profile, ["type", "id"])}
              photos={profile.images}
              lov={lov}
              blockLevel2={props.blockLevel2}
              profileAttributes={get(lov, ["profileAttributes"])}
              edit={false}
              editLocation={true}
              refresh={fetchData}
            />
          )}
        </Grid>
      </Dialog>
    </>
  );
};

export default withRouter(withStyles(styles)(ProfileDialog));
